import { useForm } from 'react-hook-form';
import { useQuery } from 'react-query';
import RestHttpClient from '../../../../../common/RestHttpClient';
import { CustomerType } from '../../../../../generated/ApiClient';

export interface KsvSearchFormValues {
  // Private
  firstName: string;
  lastName: string;
  birthDate: Date | null | undefined;
  // Commercial
  companyName: string;
  uidNumber: string | null | undefined;
  commercialRegisterNumber: string | null | undefined;
  // Shared
  street: string | undefined;
  houseNumber: string | undefined;
  zipCode: string | undefined;
  city: string | undefined;
  ksvId: string | null | undefined;
}

export function useKsvSearchForm(customerId: number, customerType: CustomerType) {
  const form = useForm<KsvSearchFormValues>({
    defaultValues: {
      firstName: '',
      lastName: '',
      birthDate: null,
      companyName: '',
      uidNumber: null,
      commercialRegisterNumber: null,
      street: undefined,
      houseNumber: undefined,
      zipCode: undefined,
      city: undefined,
      ksvId: null,
    },
  });

  const fetchCustomer = async () => {
    if (customerType === CustomerType.Commercial) {
      const result = await RestHttpClient.getCommercialCustomer(customerId);
      return result.data;
    }
    const result = await RestHttpClient.getPrivateCustomer(customerId);
    return result.data;
  };

  const { isFetching, isFetched, refetch } = useQuery({
    queryKey: ['identityCheck-ksv-form', customerType, customerId],
    queryFn: fetchCustomer,
    staleTime: Infinity,
    onSuccess: (d) => {
      if (!d) return;
      if ('companyName' in d) {
        form.reset({
          firstName: '',
          lastName: '',
          birthDate: null,
          companyName: d.companyName ?? '',
          uidNumber: d.uidNumber ?? null,
          commercialRegisterNumber: d.commercialRegisterNumber ?? null,
          street: d.addressStreet ?? undefined,
          houseNumber: d.addressHouseNumber ?? undefined,
          zipCode: d.addressPostalCode ?? undefined,
          city: d.addressCity ?? undefined,
          ksvId: d.ksvId ?? null,
        });
      } else {
        form.reset({
          firstName: d.firstName ?? '',
          lastName: d.lastName ?? '',
          birthDate: d.birthDate ?? null,
          companyName: '',
          uidNumber: null,
          commercialRegisterNumber: null,
          street: d.addressStreet ?? undefined,
          houseNumber: d.addressHouseNumber ?? undefined,
          zipCode: d.addressPostalCode ?? undefined,
          city: d.addressCity ?? undefined,
          ksvId: d.ksvId ?? null,
        });
      }
    },
  });

  return {
    form,
    loading: isFetching && !isFetched,
    refetch,
  };
}
